<!-- スピナー -->
@if (showSpinner) {
  <div class="spinner">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
}

@if (isPermissionOpen) {
  <div class="permission-overlay" (click)="togglePermission()">
    <div class="permission-panel" (click)="$event.stopPropagation()">
      <div class="text-content">{{ authDescription }}</div>
    </div>
  </div>
}

@if (!showSpinner) {
  <div class="edit-container">
    <!-- 左サイドメニュー -->
    <div class="side-menu">
      <button
        mat-raised-button
        class="save-btn"
        [disabled]="isSaving || isDeleting || !canSave"
        (click)="onSave()"
      >
        @if (isSaving) {
          <mat-spinner diameter="16"></mat-spinner>
        } @else {
          保存
        }
      </button>
      <button mat-raised-button class="cancel-btn" (click)="onCancel()">戻る</button>
      <button mat-raised-button class="delete-btn" [disabled]="isSaving || isDeleting" (click)="onDelete()">削除</button>
    </div>

    <!-- メインエリア -->
    <div class="main-area">
      <!-- ヘッダー -->
      <div class="edit-header">
        <h2 class="edit-title">組合相談</h2>
        @if (form.lastUpdatedAt) {
          <div class="last-updated">
            <div>最終更新 {{ form.lastUpdatedAt }}　</div>
            @if (form.lastUpdatedPosition) { <div>{{ form.lastUpdatedPosition }} </div> }
            <div>{{ form.lastUpdatedName }}</div>
          </div>
        }
      </div>

      <!-- フォーム -->
      <div class="form-table">

        <!-- タイトル -->
        <div class="form-row">
          <div class="form-label text">タイトル <span class="required">※</span></div>
          <div class="form-field">
            <div class="field-with-count">
              <span class="char-count">{{ form.title.length }} / 50</span>
              <input type="text" class="text-input" [(ngModel)]="form.title" maxlength="50" placeholder="タイトルを入力">
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- カテゴリー -->
        <div class="form-row">
          <div class="form-label">カテゴリー <span class="required">※</span></div>
          <div class="form-field">
            <div class="category-sub-note">※ 優先度の高い順に最大3つまで選択</div>
            <div class="category-grid">
              @for (cat of ucCategoryOptions; track cat.value) {
                <label
                  class="priority-checkbox"
                  [class.checked]="isCategorySelected(cat.value)"
                  [class.disabled]="isCategoryDisabled(cat.value)"
                  (click)="toggleCategory(cat.value); $event.preventDefault()"
                >
                  @if (getCategoryPriority(cat.value); as num) {
                    <span class="priority-num">{{ num }}</span>
                  } @else {
                    <input type="checkbox" class="priority-checkbox-native" [checked]="false" tabindex="-1"
                      [disabled]="isCategoryDisabled(cat.value)">
                  }
                  {{ cat.label }}
                </label>
              }
            </div>
          </div>
          <div class="form-action">
            <button class="reset-btn" (click)="resetCategories()">× リセット</button>
          </div>
        </div>

        <!-- 共有範囲 -->
        <div class="form-row">
          <div class="form-label">@if (authDescription && authDescription?.length != 0) {<div class="permission-trigger" (click)="togglePermission()"><mat-icon class="icon" >info</mat-icon></div>}共有範囲 <span class="required"></span></div>
          <div class="form-field">
            <div class="radio-group">
              @for (role of ucShareScopeRoleOptions; track role.value) {
                <label class="radio-label">
                  <input type="radio" name="shareScope" [(ngModel)]="shareScopeRole" [value]="role.value">
                  {{ role.label }}
                </label>
              }
            </div>
            <div class="individual-add-area">
              <button class="add-member-btn" (click)="onAddShareMember()">個別追加</button>
              <div class="added-members">
                @for (member of shareMembers; track member.id; let i = $index) {
                  <div class="member-row">
                    @if (member.position) {
                      <span class="member-position">{{ member.position }}</span>
                    }
                    <span>{{ member.name }}</span>
                    <button class="remove-btn" (click)="removeShareMember(i)"><i class="material-icons">close</i></button>
                  </div>
                }
              </div>
              <div class="drafter-row">
                <span class="drafter-label">起票者</span>
                @if (drafterInfo) {
                  <div class="member-row">
                    @if (drafterInfo.position) {
                      <span class="member-position">{{ drafterInfo.position }}</span>
                    }
                    <span>{{ drafterInfo.name }}</span>
                  </div>
                  @for (aff of drafterInfo.affiliations; track $index) {
                    <div class="org-detail-line-wrapper">
                      <div class="dot">・</div>
                      <div class="org-detail-line">{{ aff }}</div>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- 相談の概要 -->
        <div class="form-row">
          <div class="form-label text">相談の概要 <span class="required">※</span></div>
          <div class="form-field">
            <div class="field-with-count">
              <span class="char-count">{{ form.summary.length }} / 300</span>
              <textarea class="textarea-input" [(ngModel)]="form.summary" maxlength="300" rows="4"
                placeholder="相談の概要を入力"></textarea>
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- 要求・要望 -->
        <div class="form-row one-row">
          <div class="form-label">要求・要望 <span class="required"></span></div>
          <div class="form-field">
            <mat-form-field appearance="fill" class="no-line wide">
              <mat-select [(ngModel)]="form.request">
                @for (r of ucRequestOptions; track r.value) {
                  <mat-option [value]="r.value">{{ r.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- └ 備考 -->
        <div class="form-row top">
          <div class="form-label text">└ 備考 <span class="required"></span></div>
          <div class="form-field">
            <div class="field-with-count">
              <span class="char-count">{{ form.requestNote.length }} / 300</span>
              <textarea class="textarea-input" [(ngModel)]="form.requestNote" maxlength="300" rows="3"
                placeholder="備考を入力"></textarea>
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- 初回受付方法 -->
        <div class="form-row one-row">
          <div class="form-label">初回受付方法 <span class="required">※</span></div>
          <div class="form-field">
            <mat-form-field appearance="fill" class="no-line">
              <mat-select [(ngModel)]="form.receiptMethod">
                @for (m of ucReceiptMethodOptions; track m.value) {
                  <mat-option [value]="m.value">{{ m.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- 緊急度 -->
        <div class="form-row one-row">
          <div class="form-label">緊急度 <span class="required">※</span></div>
          <div class="form-field">
            <div class="radio-group">
              @for (u of ucUrgencyOptions; track u.value) {
                <label class="radio-label">
                  <input type="radio" name="urgency" [(ngModel)]="form.urgency" [value]="u.value">
                  {{ u.label }}
                </label>
              }
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- 相談者 -->
        <div class="form-row">
          <div class="form-label text">相談者 <span class="required">※</span></div>
          <div class="form-field consultant-field">
            <!-- 氏名 -->
            <div class="consultant-row">
              <div class="consultant-label text">氏名</div>
              <div class="field-with-count consultant-name">
                <span class="char-count">{{ form.consultant.name.length }} / 30</span>
                <input type="text" class="text-input" [(ngModel)]="form.consultant.name" maxlength="30" placeholder="">
              </div>
            </div>
            <!-- 年代 -->
            <div class="consultant-row">
              <div class="consultant-label">年代</div>
              <mat-form-field appearance="fill" class="no-line mini">
                <mat-select [(ngModel)]="form.consultant.ageGroup">
                  @for (a of ucAgeGroupOptions; track a.value) {
                    <mat-option [value]="a.value">{{ a.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <!-- 性別 -->
            <div class="consultant-row">
              <div class="consultant-label">性別</div>
              <mat-form-field appearance="fill" class="no-line mini">
                <mat-select [(ngModel)]="form.consultant.gender">
                  @for (g of ucGenderOptions; track g.value) {
                    <mat-option [value]="g.value">{{ g.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <!-- 連絡先 -->
            <div class="consultant-row top">
              <div class="consultant-label text">連絡先</div>
              <div class="field-with-count">
                <span class="char-count">{{ form.consultant.contact.length }} / 50</span>
                <input type="text" class="text-input" [(ngModel)]="form.consultant.contact"
                  maxlength="50" placeholder="メールアドレスや電話番号など">
              </div>
            </div>
            <!-- 所属 -->
            <div class="consultant-row flextop">
              <div class="consultant-label btn">所属</div>
              <div class="affiliation-area">
                <button class="select-btn" (click)="onSelectAffiliation()">選択</button>
                @if (consultantAffiliation?.length) {
                  <div class="affiliation-list">
                    @for (org of consultantAffiliation; track $index) {
                      <div class="org-detail-line-wrapper">
                        <div class="dot">・</div>
                        <div class="org-detail-line">{{ org.path }}</div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- 関係者 -->
        <div class="form-row">
          <div class="form-label text">関係者<br>加害/被害者など <span class="required"></span></div>
          <div class="form-field">
            <div class="field-with-count">
              <span class="char-count">{{ form.relatedParties.length }} / 300</span>
              <textarea class="textarea-input" [(ngModel)]="form.relatedParties" maxlength="300" rows="4"
                placeholder=""></textarea>
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- レポートライン -->
        <div class="form-row">
          <div class="form-label text">レポートライン<br>相談者上司など <span class="required"></span></div>
          <div class="form-field">
            <div class="field-with-count">
              <span class="char-count">{{ form.reportLine.length }} / 300</span>
              <textarea class="textarea-input" [(ngModel)]="form.reportLine" maxlength="300" rows="4"
                placeholder=""></textarea>
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- 相談・対応・報告セクション -->
        @for (session of form.sessions; track $index; let i = $index) {
          <div class="section-divider"></div>

          <!-- 相談 -->
          <div class="form-row">
            <div class="form-label session">相談 <span class="required"></span></div>
            <div class="form-field">
              <div class="session-row">
                <span class="sub-label">相談日</span>
                <div class="date-picker-trigger">
                  <button type="button" class="date-select-btn" (click)="consultPicker.open()">日付選択</button>
                  <input [matDatepicker]="consultPicker"
                         [ngModel]="sessionConsultDates[i]"
                         (dateChange)="onConsultDateChange(i, $event.value)"
                         class="date-picker-hidden-input"
                         readonly>
                  <mat-datepicker #consultPicker></mat-datepicker>
                </div>
                <span class="date-text">{{ formatDate(i, 'consult') }}</span>
              </div>
              <div class="session-row top">
                <div class="sub-label text">詳細内容</div>
                <div class="field-with-count">
                  <span class="char-count">{{ session.detail.length }} / 10000</span>
                  <textarea class="textarea-input" [(ngModel)]="session.detail" maxlength="10000" rows="5"
                    placeholder="詳細内容"></textarea>
                </div>
              </div>
            </div>
            <div class="form-action top">
              @if (i > 0) {
                <button class="reset-btn" (click)="removeSession(i)">× 削除</button>
              }
            </div>
          </div>

          <!-- 対応 -->
          <div class="form-row session-top">
            <div class="form-label session">対応 <span class="required"></span></div>
            <div class="form-field">
              <div class="session-row">
                <div class="sub-label">対応日</div>
                <div class="date-picker-trigger">
                  <button type="button" class="date-select-btn" (click)="responsePicker.open()">日付選択</button>
                  <input [matDatepicker]="responsePicker"
                         [ngModel]="sessionResponseDates[i]"
                         (dateChange)="onResponseDateChange(i, $event.value)"
                         class="date-picker-hidden-input"
                         readonly>
                  <mat-datepicker #responsePicker></mat-datepicker>
                </div>
                <span class="date-text">{{ formatDate(i, 'response') }}</span>
              </div>
              <div class="session-row top margintop">
                <div class="sub-label btn">主な対応者</div>
                <div>
                  <button class="select-btn" (click)="onSelectResponder(i)">選択</button>
                  @if (session.responders.length > 0) {
                    <div class="responders-list">
                      @for (responder of session.responders; track responder.id; let ri = $index) {
                        <div class="responder-row">
                          <div class="responder-info">
                            <div class="member-row">
                              @if (responder.position) {
                                <span class="member-position">{{ responder.position }}</span>
                              }
                              <span>{{ responder.name }}</span>
                              <button class="remove-btn" (click)="removeResponder(i, ri)"><i class="material-icons">close</i></button>
                            </div>
                            @for (aff of responder.affiliations; track $index) {
                              <div class="org-detail-line-wrapper">
                                <div class="dot">・</div>
                                <div class="org-detail-line">{{ aff }}</div>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="session-row top margintop">
                <div class="sub-label text">対応/結果</div>
                <div class="field-with-count">
                  <span class="char-count">{{ session.responseResult.length }} / 10000</span>
                  <textarea class="textarea-input" [(ngModel)]="session.responseResult" maxlength="10000" rows="5"
                    placeholder="対応/結果"></textarea>
                </div>
              </div>
            </div>
            <div class="form-action"></div>
          </div>

          <!-- 報告 -->
          <div class="form-row session-top">
            <div class="form-label text">報告 <span class="required"></span></div>
            <div class="form-field">
              <div class="session-row top">
                <div class="sub-label text">To 相談者</div>
                <div class="field-with-count">
                  <span class="char-count">{{ session.toConsultant.length }} / 300</span>
                  <textarea class="textarea-input" [(ngModel)]="session.toConsultant" maxlength="300" rows="3"
                    placeholder="相談者への報告内容"></textarea>
                </div>
              </div>
              <div class="session-row top margintop">
                <div class="sub-label text">To 関係者</div>
                <div class="field-with-count">
                  <span class="char-count">{{ session.toRelated.length }} / 300</span>
                  <textarea class="textarea-input" [(ngModel)]="session.toRelated" maxlength="300" rows="3"
                    placeholder="関係者への報告内容"></textarea>
                </div>
              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- 相談・対応・報告の追加ボタン -->
        @if (canAddSession) {
          <div class="form-row one-row">
            <div class="form-label"></div>
            <div class="form-field">
              <button class="add-session-btn" (click)="addSession()">相談・対応・報告の追加</button>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <div class="section-divider"></div>

        <!-- ステータス -->
        <div class="form-row one-row">
          <div class="form-label">ステータス <span class="required">※</span></div>
          <div class="form-field">
            <mat-form-field appearance="fill" class="no-line mini">
              <mat-select [(ngModel)]="form.status" (ngModelChange)="onStatusChange()">
                @for (s of ucStatusOptions; track s.value) {
                  <mat-option [value]="s.value">{{ s.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- 最終対応方法（完了時） -->
        @if (isCompleted) {
          <div class="form-row">
            <div class="form-label select">最終対応方法 <span class="required">※</span></div>
            <div class="form-field">
              <mat-form-field appearance="fill" class="no-line">
                <mat-select [(ngModel)]="form.finalResponseMethod">
                  @for (m of ucFinalResponseMethodOptions; track m.value) {
                    <mat-option [value]="m.value">{{ m.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <div class="select-result-area">
                <div class="sub-label">結果</div>
                <div class="radio-group">
                  @for (r of ucResultTypeOptions; track r.value) {
                    <label class="radio-label">
                      <input type="radio" name="resultType" [(ngModel)]="form.resultType" [value]="r.value">
                      {{ r.label }}
                    </label>
                  }
                </div>

              </div>
            </div>
            <div class="form-action"></div>
          </div>
        }

        <!-- ファイル添付 -->
        <div class="form-row">
          <div class="form-label upload">ファイル添付 <span class="required"></span></div>
          <div class="form-field">
            <div class="upload-btn-area">
              @if (isUploading) {
                <mat-spinner diameter="20"></mat-spinner>
              } @else {
                <button class="upload-btn" (click)="onFileSelect()" [disabled]="attachments.length >= 3">アップロード</button>
              }
              <input #fileInput type="file" class="file-input-hidden"
                [accept]="Constant.ucAttachmentAccept"
                (change)="onFileChange($event)">
              <span class="file-note">※ 3点まで、各10M以内、拡張子：pdf、jpg、png、ppt、pptx、xls、xlsx、doc、docx</span>
            </div>
            <div class="attachment-list">
              @for (att of attachments; track $index; let ai = $index) {
                <div class="attachment-item">
                  <span class="attachment-name" (click)="onDownloadAttachment(att)">{{ att.fileName }}</span>
                  <button class="remove-btn" (click)="removeAttachment(ai)"><i class="material-icons">close</i></button>
                </div>
              }
            </div>
          </div>
          <div class="form-action"></div>
        </div>

        <!-- メモ -->
        <div class="form-row">
          <div class="form-label text">メモ <span class="required"></span></div>
          <div class="form-field">
            <div class="field-with-count">
              <span class="char-count">{{ form.memo.length }} / 10000</span>
              <textarea class="textarea-input" [(ngModel)]="form.memo" maxlength="10000" rows="5"
                placeholder="メモを入力"></textarea>
            </div>
          </div>
          <div class="form-action"></div>
        </div>

      </div>
    </div>
  </div>
}
